import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';

import { AUTOMATED_LABEL_KEYS } from '../../../../../util/automated-label-keys';

type Props = ReduxFormFieldProps<Array<AutomatedLabel>>;

type State = {
  selectedOption: string;
};

const OPTIONS = {
  MINUTES: 'minutes',
  MILES: 'miles',
};

export class HardCommuteSettings extends React.PureComponent<Props, State> {
  hardCommuteMilesInput: HTMLInputElement | null;

  hardCommuteMinutesInput: HTMLInputElement | null;

  constructor(props: Props) {
    super(props);
    this.hardCommuteMilesInput = null;
    this.hardCommuteMinutesInput = null;

    const farAwayLabel = props.input.value.find(
      (l) => l.automatedLabelKey === AUTOMATED_LABEL_KEYS.IsFarAway,
    );
    const labelSetting = farAwayLabel?.AutomatedLabelSettings
      ? farAwayLabel.AutomatedLabelSettings[0]
      : null;

    this.state = {
      selectedOption: labelSetting?.hardCommuteMiles ? OPTIONS.MILES : OPTIONS.MINUTES,
    };
  }

  componentDidMount() {
    this.setInputsDisabled(this.state.selectedOption);
  }

  setInputsDisabled = (selectedOption: string | null) => {
    if (this.hardCommuteMinutesInput) {
      this.hardCommuteMinutesInput.disabled = selectedOption !== OPTIONS.MINUTES;
    }
    if (this.hardCommuteMilesInput) {
      this.hardCommuteMilesInput.disabled = selectedOption !== OPTIONS.MILES;
    }
  };

  setSelection = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const selection = (event.target as HTMLButtonElement).value;
    this.setInputsDisabled(selection);
    if (selection === OPTIONS.MINUTES && this.hardCommuteMinutesInput) {
      this.hardCommuteMinutesInput.focus();
      this.setValue('hardCommuteMiles', null);
    } else if (this.hardCommuteMilesInput) {
      this.hardCommuteMilesInput.focus();
      this.setValue('hardCommuteMinutes', null);
    }

    this.setState({
      selectedOption: selection,
    });
  };

  handleChange =
    (name: string) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      this.setValue(name, event.target.value);
    };

  setValue = (name: string, value: string | null) => {
    /*
     This insanity is due to the complex nesting we have right now in the data.
     We're returning the AutomatedLabel with an association of the AutomatedLabelSetting, which
     is what we want to change. All of this complexity is to ensure immutability, which
     is critical to making sure this re-renders as you modify the value.
     */
    const labelSettings = this.props.input.value.slice();
    const labelIndex = labelSettings.findIndex(
      (l) => l.automatedLabelKey === AUTOMATED_LABEL_KEYS.IsFarAway,
    );
    const label = { ...labelSettings[labelIndex] };
    labelSettings.splice(labelIndex, 1, label);
    const AutomatedLabelSettings = label.AutomatedLabelSettings
      ? label.AutomatedLabelSettings.slice()
      : [];
    AutomatedLabelSettings[0] = {
      ...AutomatedLabelSettings[0],
      [name]: value ? parseInt(value, 10) : null,
    };
    label.AutomatedLabelSettings = AutomatedLabelSettings;
    this.props.input.onChange(labelSettings);
  };

  render() {
    const automatedLabel = this.props.input.value.find(
      (l) => l.automatedLabelKey === AUTOMATED_LABEL_KEYS.IsFarAway,
    );
    if (!automatedLabel) {
      return null;
    }
    const { AutomatedLabelSettings } = automatedLabel;
    if (!AutomatedLabelSettings) {
      return null;
    }
    const [labelSettings] = AutomatedLabelSettings;
    return (
      <Grid container className="u-padding-left-md">
        <Grid item xs={12} container alignItems="center">
          <Grid item>
            <FormControlLabel
              label="Minutes:"
              control={
                <Radio
                  value={OPTIONS.MINUTES}
                  checked={this.state.selectedOption === OPTIONS.MINUTES}
                  onClick={this.setSelection}
                />
              }
            />
          </Grid>
          <Grid item>
            <TextField
              className="u-width-50px"
              name="hardCommuteMinutes"
              inputRef={(input) => {
                this.hardCommuteMinutesInput = input;
              }}
              value={labelSettings.hardCommuteMinutes || ''}
              onChange={this.handleChange('hardCommuteMinutes')}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} container alignItems="center">
          <Grid item>
            <FormControlLabel
              label="Miles:"
              control={
                <Radio
                  value={OPTIONS.MILES}
                  checked={this.state.selectedOption === OPTIONS.MILES}
                  onClick={this.setSelection}
                />
              }
            />
          </Grid>
          <Grid item>
            <TextField
              name="hardCommuteMiles"
              className="u-width-50px"
              inputRef={(input) => {
                this.hardCommuteMilesInput = input;
              }}
              value={labelSettings.hardCommuteMiles || ''}
              onChange={this.handleChange('hardCommuteMiles')}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
